import { TParentState } from './models/other'

export const SEARCH_DEBOUNCE_DELAY = 500
export const SEARCH_BY_CHECKED_STATE: TParentState[] = ['full', 'indeterminate']
